import React from 'react';
import { AuthContainer } from '../AuthContainer/AuthContainer';
import { useNavigate } from 'react-router-dom';
import sprite from '../../../images/sprite.svg';
import './PrivacyPolicyPage.scss';
import SecondaryButton from '../../../components/shared/Buttons/SecondaryButton/SecondaryButton';
import useWindowDimensions from '../../../hooks/widthHook';
import WestIcon from '@mui/icons-material/West';
import { useIntl } from 'react-intl';

const PrivacyPolicyPage = () => {
  const { formatMessage } = useIntl();
  const { width } = useWindowDimensions();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(-1);
  };

  return (
    <AuthContainer step={2} language={width > 1100 ? true : false}>
      <div className="PrivacyPolicyPageWrapper">
        {width < 1100 && (
          <div className="backArrow">
            <WestIcon onClick={handleClick} color="secondary" />
          </div>
        )}

        {width < 1100 && (
          <div className="PrivacyPolicyLogoWrapper">
            <svg className="logoWizwork" width={158} height={30}>
              <use href={sprite + '#icon-wizwork'}></use>
            </svg>
          </div>
        )}
        <div className="PrivacyPolicyPageWrapperShadow">
          {width > 1100 && (
            <div className="PrivacyPolicyLogoWrapper">
              <svg className="logoWizwork" width={260} height={50}>
                <use href={sprite + '#icon-wizwork'}></use>
              </svg>
            </div>
          )}
          <div className="PrivacyPolicyTextWrapper">
            <h3 className="PrivacyPolicyTitle">
              {formatMessage({ id: 'privacyPolicy' })}
            </h3>
            <p className="PrivacyPolicyText">
              {formatMessage({ id: 'privacy_1' })}
            </p>
            <p className="PrivacyPolicyText">
              {formatMessage({ id: 'privacy_2' })}
            </p>
            <p className="PrivacyPolicyText">
              {formatMessage({ id: 'privacy_3' })}
            </p>
            <p className="PrivacyPolicyText">
              {formatMessage({ id: 'privacy_4' })}
            </p>
            <h3 className="PrivacyPolicyTitle">
              {formatMessage({ id: 'privacyTitle_1' })}
            </h3>
            <p className="PrivacyPolicyText">
              {formatMessage({ id: 'privacy_5' })}
            </p>
            <p className="PrivacyPolicyText">
              {formatMessage({ id: 'privacy_6' })}
            </p>
            <p className="PrivacyPolicyText">
              {formatMessage({ id: 'privacy_7' })}
            </p>
            <h3 className="PrivacyPolicyTitle">
              {formatMessage({ id: 'privacyTitle_2' })}
            </h3>

            <p className="PrivacyPolicyText">
              {formatMessage({ id: 'privacy_8' })}
            </p>
            <p className="PrivacyPolicyText">
              {formatMessage({ id: 'privacy_9' })}
            </p>
          </div>

          {width > 1100 && (
            <SecondaryButton text="Back" onClick={handleClick} />
          )}
        </div>
      </div>
    </AuthContainer>
  );
};

export default PrivacyPolicyPage;
